import {
  mepG7Options,
  mepRef14Options,
  mepRef15Options,
  mepRef20Options,
  mepRef31Options,
  mepRef33Options,
  mepPlanActivationLevels,
} from '@/features';

import { mepContactSchema } from '../../components/mep/MepAddContact/constants';

import * as z from 'zod';

export const myEmergencyPlanFormSchema = z.object({
  // General
  activationLevel: z.enum(mepPlanActivationLevels),

  // Step 1
  g2: z.string().min(1).max(50).default(''),
  ref5Suburb: z.number(),

  // Step 2
  ref14: z.array(z.enum(mepRef14Options)).min(1).default([]),
  ref14Other: z.string().min(1).max(100),

  // Step 3
  ref15: z.array(z.enum(mepRef15Options)).min(1),

  // Step 4
  ref20: z.enum(mepRef20Options),
  ref20Other: z.string().min(1).max(100),

  g5: z.object({
    address: z.string().optional(),
    route: z.string().optional(),
  }),
  g5Address: z.string().optional(),
  g5Route: z.string().optional(),
  ref21: z.boolean(),
  ref24: z.boolean(),
  ref26: z.string().optional(),

  // Step 5
  ref27: z.boolean(),
  ref28: z.boolean(),
  ref29_1: z.boolean(),
  'ref29.1': z.boolean().optional(),
  g7: z.enum(mepG7Options),
  g7Other: z.string().min(1).max(100),

  // Step 6
  ref31: z.enum(mepRef31Options),
  ref33: z.enum(mepRef33Options),
  ref33Other: z.string().min(1).max(100),

  ref34: z.boolean(),
  ref37: z.string().optional(),

  // Step 7
  ref39: z.array(mepContactSchema).max(3),
});

export type MyEmergencyPlanFormSchema = z.infer<typeof myEmergencyPlanFormSchema>;
